<editor class="editor-component" [init]="{
    branding:false,
    toolbar:false,
    plugins:'lists paste',
    menubar:false,
    height:'150px',
    paste_as_text: true,
    readonly:true,
    setup: setupEditor
}" [(ngModel)]="model[fieldName]"></editor>